import { useCallback, useState } from 'react';

import BpkText, {
  TEXT_STYLES,
} from '@skyscanner-internal/backpack-web/bpk-component-text';

import { useDurationAutoSelect } from '../../helpers/hooks/useDurationAutoSelect';
import { useTranslation } from '../../helpers/hooks/useTranslation';

import { DurationAutoselectCardList } from './DurationAutoselectCardList';

import './DurationAutoselect.scss';

export const DurationAutoselect = () => {
  const translate = useTranslation();

  // Auto-select cheapest duration on mount
  useDurationAutoSelect();

  // Scroll position state for container styling
  const [isAtStart, setIsAtStart] = useState(true);
  const [isAtEnd, setIsAtEnd] = useState(true);

  const handleScrollPositionChange = useCallback(
    (atStart: boolean, atEnd: boolean) => {
      setIsAtStart(atStart);
      setIsAtEnd(atEnd);
    },
    [],
  );

  const containerClassName = [
    'duration-autoselect-container',
    isAtStart && 'at-start',
    isAtEnd && 'at-end',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <>
      <div className="duration-heading">
        <BpkText textStyle={TEXT_STYLES.heading5}>
          {translate('mv_cheapestDates_heading_final')}
        </BpkText>
      </div>
      <div className={containerClassName}>
        <DurationAutoselectCardList
          onScrollPositionChange={handleScrollPositionChange}
        />
      </div>
    </>
  );
};
